import React from 'react';
import PropTypes from 'prop-types';
import {
  FaEnvelope,
  // FaInfoCircle,
  FaLock,
  FaPhone,
  FaUser,
  FaUserShield,
} from 'react-icons/fa';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import InputTextNested from '../../../Components/Form/InputTextNested';

import {
  ManagerSignupContainer,
  ManagerSignupHeader,
  ManagerSignupIcon,
  ManagerSignupHeaderContent,
  ManagerSignupFields,
  ManagerSignupFieldRow,
  ManagerPreference,
  ManagerPreferenceContent,
  ManagerPreferenceCheckbox,
  PasswordError,
  ManagerSignupActions,
} from './SignupManager.styles';

const CompanyManagerSignUp = ({ user, setUser, setStep }) => {
  const passwordsMatch =
    !user?.password ||
    !user?.verifyPassword ||
    user?.password === user?.verifyPassword;

  const canContinue =
    user?.firstName?.trim() &&
    user?.lastName?.trim() &&
    user?.email?.trim() &&
    user?.password?.trim() &&
    user?.verifyPassword?.trim() &&
    passwordsMatch;

  const handleContinue = () => {
    if (!canContinue) return;

    setStep(1);
  };

  return (
    <ManagerSignupContainer>
      <ManagerSignupHeader>
        <ManagerSignupIcon>
          <FaUserShield />
        </ManagerSignupIcon>

        <ManagerSignupHeaderContent>
          <span>Your Account</span>

          <h2>Create Your Manager Account</h2>

          <p>
            This account will be used to sign in and manage your company,
            employees, and training.
          </p>
        </ManagerSignupHeaderContent>
      </ManagerSignupHeader>

      <ManagerSignupFields>
        <ManagerSignupFieldRow>
          <InputTextNested
            title={
              <>
                <FaUser />
                First Name
              </>
            }
            value={user?.firstName}
            name="firstName"
            placeholder="Joe"
            requiredInput={true}
            nestedValue={setUser}
            upperValue={user}
            containerClassName="formInputUnderline"
          />

          <InputTextNested
            title={
              <>
                <FaUser />
                Last Name
              </>
            }
            value={user?.lastName}
            name="lastName"
            placeholder="Smith"
            requiredInput={true}
            nestedValue={setUser}
            upperValue={user}
            containerClassName="formInputUnderline"
          />
        </ManagerSignupFieldRow>

        <InputTextNested
          title={
            <>
              <FaEnvelope />
              Email
            </>
          }
          value={user?.email}
          name="email"
          placeholder="joe@company.ca"
          requiredInput={true}
          nestedValue={setUser}
          upperValue={user}
          containerClassName="formInputUnderline"
        />

        <InputTextNested
          title={
            <>
              <FaPhone />
              Phone Number
            </>
          }
          value={user?.phoneNumber}
          name="phoneNumber"
          placeholder="902-555-1234"
          nestedValue={setUser}
          upperValue={user}
          containerClassName="formInputUnderline"
        />

        <ManagerSignupFieldRow>
          <InputTextNested
            title={
              <>
                <FaLock />
                Password
              </>
            }
            value={user?.password}
            name="password"
            requiredInput={true}
            nestedValue={setUser}
            upperValue={user}
            containerClassName="formInputUnderline"
          />

          <InputTextNested
            title={
              <>
                <FaLock />
                Verify Password
              </>
            }
            value={user?.verifyPassword}
            name="verifyPassword"
            requiredInput={true}
            nestedValue={setUser}
            upperValue={user}
            containerClassName="formInputUnderline"
          />
        </ManagerSignupFieldRow>

        {!passwordsMatch && (
          <PasswordError>Passwords do not match.</PasswordError>
        )}

        <ManagerPreference>
          <ManagerPreferenceCheckbox>
            <input
              id="sendCertificateToMe"
              type="checkbox"
              checked={user?.sendCertificateToMe ?? false}
              onChange={(e) =>
                setUser((prev) => ({
                  ...prev,
                  sendCertificateToMe: e.target.checked,
                }))
              }
            />

            <span aria-hidden="true" />
          </ManagerPreferenceCheckbox>

          <ManagerPreferenceContent>
            <label htmlFor="sendCertificateToMe">
              Send me employee course certificates
            </label>

            <p>
              Receive a copy of completed-course certificates in your inbox when
              employees finish their training.
            </p>
          </ManagerPreferenceContent>
        </ManagerPreference>

        <ManagerSignupActions>
          <PrimaryButton
            span="Continue to Company Info"
            functionName={handleContinue}
            disabled={!canContinue}
          />
        </ManagerSignupActions>
      </ManagerSignupFields>
    </ManagerSignupContainer>
  );
};

CompanyManagerSignUp.propTypes = {
  user: PropTypes.object.isRequired,
  setUser: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
};

export default CompanyManagerSignUp;
